import {useCallback, useEffect, useMemo, useState} from 'react'

import PropTypes from 'prop-types'

import Slider from '@s-ui/react-atom-slider'
import {useSuiContext} from '@s-ui/react-context'

import {STEP_RADIO_VALUE} from './config.js'

const FormLocationRadio = ({isDisabled = false, onChange, value}) => {
  const [currentValue, setCurrentValue] = useState()

  const {domain, i18n} = useSuiContext()

  const config = domain.get('config')

  const {DEFAULT_LOCATION_MAX_RADIO, DEFAULT_LOCATION_MIN_RADIO} = config.get('search')

  const handleChange = (_, {value}) => {
    setCurrentValue(value)
  }

  const handleSelectLocation = useCallback(
    (_, {value}) => {
      onChange({radio: value})
    },
    [onChange]
  )

  const getFormattedValue = useCallback(value => `${value}${i18n.t('COMMON.UNIT_KMS')}`, [i18n])

  const marks = useMemo(
    () => [DEFAULT_LOCATION_MIN_RADIO, DEFAULT_LOCATION_MAX_RADIO].map(getFormattedValue),
    [DEFAULT_LOCATION_MAX_RADIO, DEFAULT_LOCATION_MIN_RADIO, getFormattedValue]
  )

  useEffect(() => {
    setCurrentValue(value)
  }, [value])

  return (
    <Slider
      disabled={isDisabled}
      hideTooltip
      marks={marks}
      max={DEFAULT_LOCATION_MAX_RADIO}
      min={DEFAULT_LOCATION_MIN_RADIO}
      onAfterChange={handleSelectLocation}
      onChange={handleChange}
      step={STEP_RADIO_VALUE}
      value={currentValue}
      valueLabel={!isDisabled}
      valueLabelFormatter={getFormattedValue}
    />
  )
}

FormLocationRadio.displayName = 'FormLocationRadio'
FormLocationRadio.propTypes = {
  isDisabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number
}

export default FormLocationRadio
